import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import managementCompanyReducer from '@store/reducers/managementCompany';
import escrowCompanyReducer from '@store/reducers/escrowCompany';
import developerReducer from '@store/reducers/developer';
import lenderReducer from '@store/reducers/lender';
import policyCarrierReducer from '@store/reducers/policyCarrier';
import associationReducer from '@store/reducers/association';
import authReducer from '@store/reducers/auth';
import forgotPasswordReducer from '@store/reducers/forgotPassword';

const logger = store => {
  return next => {
    return action => {
      console.log('[Middleware] Dispatching', action);
      const result = next(action);
      console.log('[Middleware] next state', store.getState());
      return result;
    };
  };
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
  auth: authReducer,
  forgotPassword: forgotPasswordReducer,
  managementCompany: managementCompanyReducer,
  escrowCompany: escrowCompanyReducer,
  developer: developerReducer,
  lender: lenderReducer,
  policyCarrier: policyCarrierReducer,
  association: associationReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'AUTH_LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(logger, thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,

  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
